import { render } from "./FooterObjectDesc.vue?vue&type=template&id=17a6d299&scoped=true"
import script from "./FooterObjectDesc.vue?vue&type=script&lang=js"
export * from "./FooterObjectDesc.vue?vue&type=script&lang=js"

import "./FooterObjectDesc.vue?vue&type=style&index=0&id=17a6d299&lang=scss&scoped=true"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17a6d299"]])

export default __exports__